import { USER_ADMIN } from '~/constants';
import { useDetector } from '~/hooks/useDetector';

export const usePersonalPageEditable = () => {
  const userInfo = useUserInfo();
  const { isTeamRight } = useDetector();
  const route = useRoute();

  return computed(() => {
    const info = userInfo.value;
    if (!info) {
      return false;
    }
    if (+route.params.key !== info.organization_id) {
      return false;
    }
    if (isTeamRight.value && info?.permission === USER_ADMIN.NORMAL) {
      return false;
    }
    return true;
  });
};
